import { render, staticRenderFns } from "./productImportModal.vue?vue&type=template&id=5eef70d2&scoped=true&"
import script from "./productImportModal.vue?vue&type=script&lang=js&"
export * from "./productImportModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eef70d2",
  null
  
)

export default component.exports